import { Component, ojs, app } from "modular-openscriptjs";
import { either, hideActionButton, oneOf } from "../helpers";
import Card from "./Blocks/Card";
import DeliveryAddressForm from "./Forms/DeliveryAddressForm";
import { $e } from "../ojs.events";

const h = app("h");

ojs(Card, DeliveryAddressForm);

export default class DeliveryAddress extends Component {
    render(addresses, ...args) {
        let hide = "";
        let address = {};

        if (addresses.value.length == 0) hide = "d-none";
        else address = addresses.value[addresses.value.length - 1]; // Fix access to .value

        return h.div(
            h.div(
                {
                    class: "d-flex flex-column",
                    id: "chosen-address-div",
                    data_address: oneOf(address?.id, 0),
                },

                either(
                    addresses.value.length,
                    () =>
                        h.div(
                            {
                                class: `card border-0 shadow-sm rounded-4 p-4 mb-3 bg-white ${hide}`,
                            },
                            h.div(
                                {
                                    class: "d-flex justify-content-between align-items-start mb-3",
                                },
                                h.div(
                                    h.h6(
                                        {
                                            class: "fw-bold text-muted text-uppercase small mb-1",
                                        },
                                        "Delivery Location",
                                    ),
                                    h.div(
                                        {
                                            class: "fw-bold text-dark fs-5 mb-1 d-flex gap-2",
                                        },
                                        h.span(
                                            h.i({
                                                class: "fas fa-map-pin text-primary",
                                            }),
                                        ),
                                        h.span(address?.address),
                                    ),
                                ),
                                h.div(
                                    {
                                        class: "badge bg-light text-primary border p-2 rounded-3",
                                    },
                                    "Selected",
                                ),
                            ),
                            h.div(
                                { class: "mb-3 py-2 px-3 bg-light rounded-3" },
                                either(
                                    address?.recipient_name || address?.phone,
                                    () => [
                                        either(address?.recipient_name, () =>
                                            h.div(
                                                {
                                                    class: "d-flex align-items-center gap-2 mb-1",
                                                },
                                                h.i({
                                                    class: "fas fa-user text-muted small",
                                                }),
                                                h.span(
                                                    {
                                                        class: "fw-medium text-dark small",
                                                    },
                                                    address?.recipient_name,
                                                ),
                                            ),
                                        ),
                                        either(address?.phone, () =>
                                            h.div(
                                                {
                                                    class: "d-flex align-items-center gap-2 mb-1",
                                                },
                                                h.i({
                                                    class: "fas fa-phone text-muted small",
                                                }),
                                                h.span(
                                                    {
                                                        class: "fw-medium text-dark small",
                                                    },
                                                    address?.phone,
                                                ),
                                            ),
                                        ),
                                    ],
                                    () =>
                                        either(
                                            address?.first_name ||
                                                address?.last_name ||
                                                address?.phone,
                                            () => [
                                                either(
                                                    address?.first_name ||
                                                        address?.last_name,
                                                    () =>
                                                        h.div(
                                                            {
                                                                class: "d-flex align-items-center gap-2 mb-1",
                                                            },
                                                            h.i({
                                                                class: "fas fa-user text-muted small",
                                                            }),
                                                            h.span(
                                                                {
                                                                    class: "fw-medium text-dark small",
                                                                },
                                                                `${[address?.first_name, address?.last_name].filter(Boolean).join(" ")}`,
                                                            ),
                                                        ),
                                                ),
                                                either(address?.phone, () =>
                                                    h.div(
                                                        {
                                                            class: "d-flex align-items-center gap-2 mb-1",
                                                        },
                                                        h.i({
                                                            class: "fas fa-phone text-muted small",
                                                        }),
                                                        h.span(
                                                            {
                                                                class: "fw-medium text-dark small",
                                                            },
                                                            address?.phone,
                                                        ),
                                                    ),
                                                ),
                                            ],
                                        ),
                                ),
                                either(address?.additional_information, () =>
                                    h.div(
                                        {
                                            class: "d-flex align-items-start gap-2 mt-2 text-secondary small",
                                        },
                                        either(
                                            address?.recipient_name ||
                                                address?.phone,
                                            { class: "pt-2 border-top " },
                                        ),
                                        h.i({
                                            class: "fas fa-info-circle text-muted",
                                        }),
                                        h.span(address?.additional_information),
                                    ),
                                ),
                            ),
                            h.div(
                                {
                                    class: "d-flex justify-content-between align-items-center pt-2",
                                },
                                h.button(
                                    {
                                        class: "btn btn-link text-primary text-decoration-none fw-semibold p-0 small",
                                        onclick: this.method("addNewAddress"),
                                    },
                                    h.i({ class: "fas fa-plus me-1" }),
                                    "New",
                                ),
                                h.button(
                                    {
                                        class: "btn btn-link text-secondary text-decoration-none fw-medium p-0 small",
                                        onclick: this.method('showAddressList'),
                                        href: "#",
                                    },
                                    h.i({ class: "fas fa-exchange-alt me-1" }),
                                    "Change",
                                ),
                            ),
                        ),
                    () =>
                        h.div(
                            {
                                class: "card border-0 shadow-sm rounded-4 p-4 mb-3 bg-white text-center",
                            },
                            h.div(
                                { class: "mb-3 text-muted" },
                                h.i({
                                    class: "fas fa-map-location-dot fa-3x text-muted mb-2 opacity-50",
                                }),
                            ),
                            h.h6(
                                { class: "fw-bold text-dark mb-1" },
                                "No Delivery Address",
                            ),
                            h.p(
                                { class: "text-secondary small mb-4" },
                                "Please add a delivery address to complete your order.",
                            ),
                            h.button(
                                {
                                    class: "btn btn-primary w-100 rounded-pill fw-bold py-3",
                                    style: "background: linear-gradient(-45deg, #973e87, #d946a6, #7a3270, #973e87); background-size: 400% 400%; animation: gradient 5s ease infinite; border: none;",
                                    onclick: `sendEvent('${$e.user.needs.addressForm}')`,
                                },
                                h.i({ class: "fas fa-plus me-2" }),
                                "Add Address",
                            ),
                        ),
                ),
            ),
            ...args,
        );
    }

    addNewAddress() {
        hideActionButton();
        app("broker").send($e.user.needs.addressForm);
    }

    showAddressList() {
        hideActionButton();
        app("broker").send($e.deliveryAddress.needs.addressList);
    }
}

ojs(DeliveryAddress);
